import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faDiscord,
  faSteam,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUserSecret, faGithub, faDiscord, faSteam);

Vue.component("font-awesome-icon", FontAwesomeIcon);
